import { render, staticRenderFns } from "./BtnSalvar.vue?vue&type=template&id=7de4e05f&"
import script from "./BtnSalvar.vue?vue&type=script&lang=js&"
export * from "./BtnSalvar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports